﻿$.fn.dxCtrlRadioGroup = function custom_dxCtrlRadioGroup(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlradiogroup");
        this.instance = new cdxCtrlRadioGroup(this, option);
    }
    return this;
}

window.cdxCtrlRadioGroup = function (container, option) {
    var Me = this;
    if (typeof option.allowAnnuleSelection == 'undefined') option.allowAnnuleSelection = false;
    if (typeof option.disablePropagation == 'undefined') option.disablePropagation = false;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dxTxtFocus = null
    var dx = null;
    var $DivLabel = null;
    function mConstruit() {
        container.empty();
        container.css("padding", "5px 15px")


        var onfocusout = option.onFocusOut
        var timeOutFocus = null
        dxTxtFocus = $('<div>').appendTo(container).dxTextBox({
            width: 0,
            height: 0,
            visible: true,
            onFocusOut: function (e) {
                if (typeof onfocusout != 'undefined') {
                    timeOutFocus = window.setTimeout(function () {
                        onfocusout()
                    }, 150)
                }
            },
            onFocusIn: function (e) {
                window.clearTimeout(timeOutFocus)
            }
        }).dxTextBox("instance")
        option.onFocusOut = null
        option.onFocusIn = function () { dxTxtFocus.focus() }

        var oncontentready = option.onContentReady

        option.onContentReady = function (e) {
            if (option.allowAnnuleSelection) {
                e.component.element().find(".dx-radiobutton").on("click", function () {
                    if ($(this).hasClass("dx-radiobutton-checked")) {
                        e.component.option("value", null)
                        if (typeof option.onAnnuleSelection != 'undefined') option.onAnnuleSelection(e)
                        return false;
                    }
                })
            }
            if (typeof option.color != 'undefined') e.component.element().find(".dx-item-content").css("color", option.color)
            if (typeof oncontentready != 'undefined' && oncontentready) oncontentready(e)
        }

        //if (typeof option.focusStateEnabled == 'undefined') option.focusStateEnabled = false

        var onvaluechanged = option.onValueChanged
        option.onValueChanged = function (e) {
            if (option.disablePropagation && typeof e.event != "undefined") { e.event.preventDefault(); e.event.stopPropagation(); }
            if (typeof onvaluechanged != 'undefined') onvaluechanged(e)
        }


        if (option.labelMode == "floating") {
            container.css({ "position": "relative", "padding-top": "5px" })
            $DivLabel = $('<div class="dx-texteditor-label" style="left: 16px;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
        }

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        dx = $("<div/>").appendTo(container).dxRadioGroup(option).dxRadioGroup("instance")

        dxTxtFocus.focus()
    }

    mConstruit();

    this.focus = function () { dxTxtFocus.focus(); }
    this.component = function () { return dx; }
    this.element = function () { return container; }
}